import { CheckList } from './check-list';
import { attachPropertiesToComponent } from '../utils/attach-properties-to-component';
import { CheckListItem } from './check-list-item';
// prettier-ignore-start
export type { CheckListProps } from './check-list';
export type { CheckListItemProps } from './check-list-item';
// prettier-ignore-end

export default attachPropertiesToComponent(CheckList, {
  Item: CheckListItem,
});
